export default __webpack_public_path__ + "static/media/rounded-car.c60087fc.webp";